<template>
    <div class="image-data-config-viewer">
        <img v-if="item.image && item.image.publicUrl"
             :src="item.image.publicUrl"
             :style="{ width: (item.width || 80) + 'px', height: (item.height || 80) + 'px', objectFit: item.objectFit || 'contain', display: 'block' }" />
        <div v-else class="img-placeholder"
             :style="{ width: (item.width || 80) + 'px', height: (item.height || 80) + 'px' }">
            <icon-image />
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class ImageDataConfigViewer extends Vue {
    @Prop() item: OM.ImageDataConfig;
}
</script>

<style scoped>
.img-placeholder {
    border: 2px dashed #dee2e6;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    color: #6c757d;
}
</style>
